var cov_hkgx0fpgj = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Gap/styles/index.js",
      hash = "0abc2655d5f0ff0678fb480bdc6fbc10e1537745",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Gap/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 5,
          column: 50
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var GapLess = {};
import genaration from '../../utils/classname';
export var gapClass = (cov_hkgx0fpgj.s[0]++, genaration(GapLess, 'gap'));